import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

import { Helmet } from "react-helmet";
import ReactGA from "react-ga";

import Home from "containers/Home";
import Collections from "containers/Collections";

import Info from "containers/Info";
import Accessibility from "containers/Accessibility";
import MainNav from "components/MainNav";
import Header from "components/Header";
import SubNav from "components/SubNav";
import A from "shared/A";
import Div from "shared/Div";
import Flex from "shared/Flex";
import MobileNav from "components/MobileNav";
import Link from "shared/Link";
import HashLink from "shared/HashLink";
import GA from "utils/Analytics";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubNav: false,
      showHamburger: false,
      screenSize: 0,
      small: false,
    };
  }

  componentWillMount() {
    window.addEventListener("resize", this.onResize);

    this.onResize();
  }

  componentWillUpdate(newProps) {
    if (newProps.location.pathname !== this.props.location.pathname) {
      // window.scrollTo(0,0)
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  showSubNav = (bool) => {
    this.setState({
      showSubNav: bool,
    });
  };

  toggleMenu = (bool) => {
    this.setState({
      showHamburger: bool,
    });
  };

  onResize = () => {
    this.setState({
      screenSize: window.innerWidth,
      small: window.innerWidth < 760,
    });
  };

  render() {
    let seasons = [
      "SS24",
      "SS23",
      "AW21",
      "SS21",
      "AW20",
      "SS20",
      "AW19",
      "SS19",
      "AW18",
      "SS18",
      "AW17",
      "SS17",
    ];
    return (
      <div
        style={{ minHeight: "100vh", maxWidth: "100vw", overflowX: "hidden" }}
      >
        <Helmet>
          <title>Barragán</title>
          <meta name="description" content="Barragán"></meta>
        </Helmet>
        {this.props.location.pathname !== "/" && (
          <Header
            openMenu={() => this.toggleMenu(true)}
            small={this.state.small}
          />
        )}
        {this.state.small && this.state.showHamburger && (
          <MobileNav closeMenu={() => this.toggleMenu(false)}></MobileNav>
        )}
        {!this.state.small && (
          <MainNav column={false}>
            <Div
              zIndex="15"
              onMouseEnter={() => this.showSubNav(true)}
              onMouseOver={() => this.showSubNav(true)}
              onMouseOut={() => this.showSubNav(false)}
              width="auto"
              height="auto"
            >
              <Flex column justifyContent="flex-end">
                <Flex column animate>
                  {seasons.map((s, i) => (
                    <HashLink
                      underline="true"
                      key={i}
                      to={`/collections#${s}`}
                      style={{
                        display: this.state.showSubNav ? "flex" : "none",
                      }}
                    >
                      {s}
                    </HashLink>
                  ))}
                </Flex>
                <Link
                  background="white"
                  border="true"
                  padding="0 10px"
                  margin="0 1.5em 0 0"
                  to="/collections"
                >
                  Collections
                </Link>
              </Flex>
            </Div>
            <A
              background="white"
              border="true"
              padding="0 10px"
              margin="0 1.5em 0 0"
              href="https://shop.barragannnn.com/"
              target="_blank"
            >
              Shop
            </A>
            <A
              background="white"
              border="true"
              padding="0 10px"
              margin="0 1.5em 0 0"
              href="https://shop.barragannnn.com/pages/policy-1"
              target="_blank"
            >
              Policy
            </A>
            <Link
              background="white"
              border="true"
              padding="0 10px"
              margin="0 1.5em 0 0"
              to="/contact"
            >
              Contact
            </Link>
            <A
              background="white"
              border="true"
              padding="0 10px"
              margin="0 1.5em 0 0"
              href="https://www.instagram.com/barragan/"
              target="_blank"
            >
              @barragan
            </A>
            <Link
              background="white"
              border="true"
              padding="0 10px"
              margin="0 1.5em 0 0"
              to="/accessibility"
            >
              Accessibility
            </Link>
          </MainNav>
        )}

        {GA.init() && <GA.RouteTracker />}
        <Switch>
          <Route
            exact
            path="/"
            render={(props) => <Home {...props} small={this.state.small} />}
          />
          <Route
            path="/contact"
            render={(props) => <Info {...props} small={this.state.small} />}
          />
          <Route
            path="/accessibility"
            render={(props) => (
              <Accessibility {...props} small={this.state.small} />
            )}
          />
          <Route
            path="/collections"
            render={(props) => (
              <Collections {...props} small={this.state.small} />
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default App;

/*
  NOTE: ROUTING EXAMPLES:

  <Switch>
    <Route exact path='/' component={Home}/>
    <Route path='/roster' component={Roster}/>
    <Route path='/roster/:number' component={Player}/>
      NOTE: number will be stored as match.params.number
    <Route path='/schedule' component={Schedule}/>
  </Switch>

  // NOTE: when nesting Routes within other components, it's important that the inner nested ones are the ones that have exact or else it will only render the outer components

  NOTE: Only one of the following should be supplied as a prop to a Route element:

    ----- component, render, or children ------

    - COMPONENT - simple, passes a Component
    - RENDER - similar to component, but useful to pass extra props or inline rendering
    - CHILDREN - returns react element, but will always be rendered regardless of whether route's path matches location

    <Route path='/page' component={Page} />

    const extraProps = { color: 'red' }
    <Route path='/page' render={(props) => (
      <Page {...props} data={extraProps}/>
    )}/>

    <Route path='/page' children={(props) => (
      props.match
        ? <Page {...props}/>
        : <EmptyPage {...props}/>
    )}/>

    NOTE: LINKING

    <Link to='/roster'>Roster</Link>

    'to' can be either a string (like above) or a location object containing any of the following:
        -pathname, search, hash, state
        example: to={{pathname: '/roster/7'}}

 */



// WEBPACK FOOTER //
// ./src/containers/App.js